<div class="comment-list-heading">
  <h3>{{'comments'| translation}}</h3>
  <div><scaffold-toggle-slide status="info" size='small' [(ngModel)]="showResolved">{{'show_resolved'| translation}}</scaffold-toggle-slide></div>
</div>
<div *ngFor="let group of comments">
  <h3>{{group.name}}</h3>
  <app-comments-board [comments]="filterUser(group.comments)" [hideClose]="true" [showResolved]="showResolved"></app-comments-board>
</div>
